/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import React from "react";
import {debug} from "./miscUtil";
import {getScreenHeight, getScreenWidth} from "./responsiveUtil";
import {generateUUID} from "./controlUtil";

export const generateComponentId = (id?: string | null, lettersOnly: boolean = true): string => {
    if (id !== null && id !== undefined) return id;
    const generated = generateUUID();
    let compId = generated.substring(0, generated.indexOf('-', generated.indexOf('-') + 1));
    if (lettersOnly)
        compId = compId.split('').map((char: string) => Number.isNaN(char) ? char : String.fromCharCode(97 + Number(char))).join('');
    return compId;
};

export const navigate = (url: string, stripQuery: boolean = true, move: boolean | string = true,
                         customScroller?: (id?: boolean | string) => void) => {
    let navigator = document.getElementById('appNavigator');
    if (navigator) {
        navigator.dataset.url = url;
        if (stripQuery) navigator.dataset.strip = '1';
        navigator.click();

        if (customScroller) {
            directTimeout(() => {
                customScroller(move);
            });
        } else if (typeof move === 'string') {
            directTimeout(() => {
                const element = document.getElementById(move);
                if (element) element.scrollIntoView({block: "start", behavior: "smooth"});
            });
        } else if (move) directTimeout(() => {
            window.scrollTo(0, 0)
        });
    } else debug('Navigator not found');
};

export const elementIsInView = (element: HTMLElement): boolean => {
    const box = element.getBoundingClientRect();
    return box.top >= 0 && box.left >= 0 && box.bottom <= getScreenHeight() && box.right <= getScreenWidth();
};

export const directTimeout = (handler: Function) => {
    window.setTimeout(handler, 0);
};

export const getElementTop = (element: string | HTMLElement | null): number => {
    if (typeof element === 'string') element = document.getElementById(element);
    if (element) {
        const box = element.getBoundingClientRect(),
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return box.top + scrollTop;
    }
    return 0;
};